<template>
	<div class="container">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-form @submit="onSubmit">
			<van-field
				v-model="form.order_name"
				label="项目名称"
				placeholder="请填写项目名称"
				:rules="[{ required: true, message: '请填写项目名称' }]"
			/>
			<van-field
				v-model="order_type_text"
				label="订单类型"
				placeholder="请选择订单类型"
				readonly
				@click="picker.order_type = true"
				:rules="[{ required: true, message: '请选择订单类型' }]"
			/>
			<van-field
				v-model="form.goods"
				label="选择商品"
				placeholder="请选择商品"
				readonly
				@click="picker.goods = true"
			/>
			<van-field name="radio" label="付款方式">
				<template #input>
					<van-radio-group v-model="form.payment_method" direction="horizontal">
						<van-radio name="0" v-if="form.order_type != 4">全款</van-radio>
						<van-radio name="1" v-if="form.order_type != 0 && form.order_type != 4">预付</van-radio>
						<van-radio name="2" v-if="form.order_type != 4">欠款授信</van-radio>
						<van-radio
							style="margin-top: 8px;"
							name="3"
							v-if="form.order_type == 0 || form.order_type == 4"
						>产品借用</van-radio>
					</van-radio-group>
				</template>
			</van-field>
			<div v-if="form.payment_method==1">
				<div class="input-right">
					<van-field
						v-model="payment[0].number"
						label="首付"
						placeholder="请填写首付"
						type="number"
						:rules="[{ required: true, message: '请填写首付' }]"
						@input="updateInput(0)"
					/>
					<van-tag class="input-tag" plain>{{payment[0].percentage}}</van-tag>
				</div>
				<div class="input-right">
					<van-field
						v-model="payment[1].number"
						label="	货到现场"
						placeholder="请填写货到现场"
						type="number"
						:rules="[{ required: true, message: '请填写货到现场' }]"
						@input="updateInput(1)"
					/>
					<van-tag class="input-tag" plain>{{payment[1].percentage}}</van-tag>
				</div>
				<div class="input-right">
					<van-field
						v-model="payment[2].number"
						label="安装完毕"
						placeholder="请填写安装完毕"
						type="number"
						:rules="[{ required: true, message: '请填写安装完毕' }]"
						@input="updateInput(2)"
					/>
					<van-tag class="input-tag" plain>{{payment[2].percentage}}</van-tag>
				</div>
				<div class="input-right">
					<van-field
						v-model="payment[3].number"
						label="安装完验收"
						placeholder="请填写安装完验收"
						type="number"
						:rules="[{ required: true, message: '请填写安装完验收' }]"
						@input="updateInput(3)"
					/>
					<van-tag class="input-tag" plain>{{payment[3].percentage}}</van-tag>
				</div>
				<div class="input-right">
					<van-field
						v-model="payment[4].number"
						label="质保金"
						placeholder="请填写质保金"
						type="number"
						:rules="[{ required: true, message: '请填写质保金' }]"
						@input="updateInput(4)"
					/>
					<van-tag class="input-tag" plain>{{payment[4].percentage}}</van-tag>
				</div>
				<van-field
					v-model="payment[5].number"
					label="质保天数"
					placeholder="请填写质保天数"
					type="number"
					:rules="[{ required: true, message: '请填写质保天数' }]"
				/>
			</div>
			<van-field
				v-model="client_id_text"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="picker.client = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field name="radio" label="是否含税">
				<template #input>
					<van-radio-group v-model="form.order_tax" direction="horizontal">
						<van-radio name="0" >含税</van-radio>
						<van-radio name="1" >不含税</van-radio>
					</van-radio-group>
				</template>
			</van-field>
			<van-field
				v-model="beneficiary_id_text"
				label="收款账户"
				placeholder="选择收款账户"
				readonly
				@click="picker.beneficiary = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '选择收款账户' }]"
			/>
			<van-field
				v-model="form.paid_account"
				label="已付金额"
				placeholder="请填写已付金额"
				type="number"
				:rules="[{ required: true, message: '请填写已付金额' }]"
			/>
			<van-field
				v-model="form.receipt_name"
				label="收货人"
				placeholder="请填写收货人"
				:rules="[{ required: true, message: '请填写收货人' }]"
			/>
			<van-field
				v-model="form.receipt_phone"
				label="联系方式"
				placeholder="请填写联系方式"
				type="tel"
				:rules="[{ required: true, message: '请填写联系方式' }]"
			/>
			<van-field
				v-model="form.delivery_address"
				label="配送地址"
				placeholder="请填写配送地址"
				:rules="[{ required: true, message: '请填写配送地址' }]"
			/>
			<van-field
				v-model="form.deliver_date"
				label="交付日期"
				placeholder="选择交付日期"
				readonly
				@click="picker.calendar = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择交付日期' }]"
			/>
			<van-field
				v-model="form.back_date"
				label="回款日期"
				placeholder="选择回款日期"
				readonly
				@click="picker.calendarBack = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择回款日期' }]"
				v-if="form.payment_method ==1 || form.payment_method ==2"
			/>
			<van-field
				v-model="form.return_date"
				label="归还日期"
				placeholder="选择归还日期"
				readonly
				@click="picker.calendarReturn = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择归还日期' }]"
				v-if="form.order_type==4"
			/>
			<van-field
				v-model="form.order_remark"
				rows="3"
				autosize
				label="备注"
				type="textarea"
				placeholder="请输入备注"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写备注' }]"
			/>
			<van-field name="uploader" label="附件上传" :rules="[{ required: true, message: '请上传附件' }]">
				<template #input>
					<van-uploader v-model="uploader" :max-count="6" accept="all" icon="upgrade" :after-read="onAfterRead"/>
				</template>
			</van-field>
			<van-submit-bar :price="price" button-text="提交订单" />
		</van-form>

		<van-panel
			class="goods-panel"
			v-for="(item, index) in goodsList"
			:key="index"
			:title="item.name"
			:desc="item.remark"
		>
			<div>
				<van-cell title="数量" :value="item.quantity || 1" />
				<van-cell title="价格" :value="item.amount || 0" />
				<van-cell title="总价" :value="item.totalPrice || 0" />
			</div>
			<template #footer style="overflow: hidden;">
				<van-button size="small" type="primary" @click="updateGoods(index)" style="margin-right: 10px;">修改</van-button>
				<van-button size="small" type="danger" @click="delGoods(index)" v-if="item.name != '其他费用'">删除</van-button>
			</template>
		</van-panel>

		<van-popup v-model="picker.goods" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="goods.list"
				@onload="onloadGoods"
				@check="checkGoods"
				:loading="goods.loading"
				:finished="goods.finished"
				value-key="product_name"
			></popup-select>
		</van-popup>
		<van-popup v-model="picker.order_type" position="bottom">
			<van-picker
				show-toolbar
				:columns="order_type"
				@cancel="picker.type = false"
				@confirm="confirmType"
			/>
		</van-popup>
		<van-popup
			v-model="picker.select"
			style="width: 80%; padding: 10px;"
			round
			:close-on-click-overlay="false"
			@close="closeSelect"
			closeable
		>
			<van-form @submit="subSelect">
				<van-field v-model="selectForm.name" label="商品名" readonly />
				<van-field
					v-model="selectForm.quantity"
					label="数量"
					placeholder="请填写数量"
					type="number"
					:rules="[{ required: true, message: '请填写数量' }]"
				/>

				<van-field
					v-model="selectForm.amount"
					label="单价"
					placeholder="请填写单价"
					type="text"
					:rules="[{ required: true, message: '请填写单价' }]" 
					@input="amountRules"
				/>

				<van-field
					v-model="selectForm.remark"
					label="备注"
					placeholder="请填写备注"
					rows="3"
					autosize
					type="textarea"
				/>
				<van-button round block type="info" native-type="submit">提交</van-button>
			</van-form>
		</van-popup>
		<van-popup v-model="picker.client" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onloadClient"
				@check="checkClient"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
		<van-popup v-model="picker.beneficiary" position="bottom">
			<van-picker
				show-toolbar
				:columns="beneficiaryList.list"
				@cancel="picker.beneficiary = false"
				@confirm="confirmBeneficiary"
				value-key="receiving_account"
			/>
		</van-popup>
		<van-calendar v-model="picker.calendar" @confirm="confirmCalendar" />
		<van-calendar v-model="picker.calendarBack" @confirm="confirmCalendarBack" />
		<van-calendar v-model="picker.calendarReturn" @confirm="calendarReturn" />
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import popupselect from "@/components/select/index";
import { getNowFormatDate } from "@/utils/tool";
import { post } from "@/api/order";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 

export default {
	components: {
		navbar,
		"popup-select": popupselect
	},
	data() {
		return {
			title: "新增订单",
			activeName: "index",
			price: 0,
			order_type_text: "",
			client_id_text: "",
			beneficiary_id_text: "",
			form: {
				order_name: "",
				order_type: "",
				payment_method: "0",
				goods: "",
				client_id: "",
				beneficiary_id: "",
				deliver_date: "",
				order_remark: "",
				return_date: "",
				paid_account: "",
				receipt_name: "",
				receipt_phone: "",
				delivery_address: "",
				order_tax: "0",
				back_date: ""
			},
			uploader: [],
			picker: {
				goods: false,
				order_type: false,
				select: false,
				client: false,
				beneficiary: false,
				calendar: false,
				calendarBack: false,
				calendarReturn: false
			},
			order_type: [
				{ text: "渠道批发", value: 0 },
				{ text: "成品制作", value: 1 },
				{ text: "工程安装", value: 2 },
				{ text: "指导安装", value: 3 },
				{ text: "产品借用", value: 4 },
				{ text: "保外维修", value: 5 }
			],
			goods: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25,
			},
			selectForm: {
				product_id: "",
				name: "",
				quantity: "",
				amount: "",
				remark: "",
				totalPrice: ""
			},
			goodsList: [
				{
					name: "其他费用",
					other_fee_quantity: "1",
					other_fee: "0",
					other_fee_remark: "",
					totalPrice: "0"
				}
			],
			beneficiaryList: {
				requestType: "receiving_account_list",
				list: []
			},
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25,
			},
			goodsIndex: "",
			goodsInfo: 0,
			payment: [
				{ number: "", percentage: "0%" },
				{ number: "", percentage: "0%" },
				{ number: "", percentage: "0%" },
				{ number: "", percentage: "0%" },
				{ number: "", percentage: "0%" },
				{ number: "" }
			]
		};
	},
	mounted() {
		this.getBeneficiaryList();
	},
	methods: {
		amountRules() {
			const isOtherFee = this.selectForm.name === '其他费用';
			const amount = parseFloat(this.selectForm.amount);
			console.log(amount, isOtherFee);
			if (isOtherFee) {
				if (/^[-]?\d*\.?\d*$/.test(this.selectForm.amount) || this.selectForm.amount === '') {
					// 合法输入，不做处理
				} else {
					// 非法输入，移除非数字字符（保留负号和小数点）
					this.selectForm.amount = this.selectForm.amount.replace(/[^-0-9.]/g, '');
				}
			} else {
				// 允许输入数字和小数点
				if (/^\d+(\.\d+)?$/.test(this.selectForm.amount) || this.selectForm.amount === '') {
					// 合法输入，不做处理
				} else {
					// 非法输入，移除非数字字符（保留数字和小数点）
					this.selectForm.amount = this.selectForm.amount.replace(/[^0-9.]/g, '');
				}
			}
		},
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		onSubmit() {
			let total = this.price / 100;
			const totalNum = parseFloat(total);
			const paidAccountNum = parseFloat(this.form.paid_account);
			
			if(this.form.payment_method == 0){
				if(paidAccountNum != totalNum){
				Toast.fail("付款金额与实收金额不一致");
				return;
				}
			}
			if (this.uploader.length === 0) {
				Toast.fail("请上传附件");
				return;
			}
			let formData = new FormData();
			let data = this.form;
			const otherFeeItem = { ...this.goodsList[0] }; // 复制“其他费用”防止引用污染
			const selectedGoods = this.goodsList.slice(1); // 获取用户选择的商品
			data.product_list = this.goodsList;
			data.other_fee = this.goodsList[0].other_fee;
			data.other_fee_quantity = this.goodsList[0].other_fee_quantity;
			data.other_fee_remark = this.goodsList[0].other_fee_remark;
			data.product_list.splice(0, 1);

			console.log(data);

			data.payment_sf = this.payment[0].number;
			data.payment_hdxc = this.payment[1].number;
			data.payment_azwb = this.payment[2].number;
			data.payment_azwys = this.payment[3].number;
			data.warranty = this.payment[4].number;
			data.warranty_days = this.payment[5].number;

			for (let i = 0; i < this.uploader.length; i++) {
				formData.append("file", this.uploader[i].file);
			}
			formData.append("data", JSON.stringify(data));
			formData.append("requestType", "sales_order_save");
			formData.append("token", getToken());

			const config = {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			};
			axios.post(this.GLOBAL.httpURL, formData, config).then(res => {
				console.log(res);
				if (res.status === 200) {
					if (res.data.code === 200) {
						Toast.fail("新增订单成功!");
						this.$router.go(-1);
					} else if (res.data.code === 301) {
						Toast.fail("参数验证错误!");
						// 提交失败时恢复 goodsList 结构
						this.goodsList = [otherFeeItem, ...selectedGoods];
					} else {
						Toast.fail("未知错误!");
						// 提交失败时恢复 goodsList 结构
						this.goodsList = [otherFeeItem, ...selectedGoods];
					}
				} else {
					Toast.fail("网路连接错误,请稍后重试!");
						// 提交失败时恢复 goodsList 结构
						this.goodsList = [otherFeeItem, ...selectedGoods];
				}
			});
		},
		confirmType(value) {
			this.form.order_type = value.value;
			this.order_type_text = value.text;
			this.picker.order_type = false;
		},
		onloadGoods(search) {
			// 防止重复请求
			if (this.goods.loading) {
				return;
			}
			// 设置加载状态
			this.goods.loading = true;
			if (search != undefined) {
				this.goods.page = 1;
				this.goods.product_name = search;
			} else {
				this.goods.product_name = "";
			}
			post({
			requestType: "sales_product_list",
				page: this.goods.page,
				limit: this.goods.limit,
				product_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.goods.finished = true;
					}
					if (this.goods.page != 1) {
						this.goods.list = this.goods.list.concat(res.obj.rows);
					} else {
						this.goods.list = res.obj.rows;
					}

					this.goods.page += 1;
					this.goods.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.goods.loading = false;
					this.goods.finished = true;
					return Toast.fail("数据异常");
				});
		},
		checkGoods(value) {
			// 防止重复选择
			const exists = this.goodsList.some(item => item.product_id === value.product_id);
			if (exists) {
				Toast.fail("该商品已存在，请勿重复选择");
				return;
			}
			this.selectForm.name = value.product_name;
			this.selectForm.product_id = value.product_id;
			this.selectForm.quantity = "";
			this.selectForm.amount = "";
			this.selectForm.remark = "";
			this.selectForm.totalPrice = "";
			this.goodsInfo = 0;
			this.picker.select = true;
			this.updatePrice();
			this.picker.goods = false;
		},
		subSelect() {
			const newProduct = {
				product_id: this.selectForm.product_id,
				name: this.selectForm.name,
				quantity: this.selectForm.quantity,
				amount: this.selectForm.amount,
				remark: this.selectForm.remark,
				totalPrice: this.selectForm.quantity * this.selectForm.amount
			};
			if (this.goodsInfo == 0) {
				this.goodsList.push(newProduct);
			} else if (this.goodsInfo == 1) {
				this.goodsList[this.goodsIndex] = newProduct;
				if (this.goodsIndex == 0) {
					this.goodsList[0].other_fee_quantity = this.selectForm.quantity;
					this.goodsList[0].other_fee = this.selectForm.amount;
					this.goodsList[0].other_fee_remark = this.selectForm.remark;
				}
			} else {
				this.goodsList.splice(this.goodsIndex, 1);
			}
			// 清空当前选择表单
			this.selectForm = {
				product_id: "",
				name: "",
				quantity: "",
				amount: "",
				remark: "",
				totalPrice: ""
			};
			this.picker.select = false;
			this.updatePrice();
		},
		updateGoods(index) {
			this.selectForm = this.goodsList[index];
			this.goodsInfo = 1;
			this.goodsIndex = index;
			this.picker.select = true;
			this.updatePrice();
		},
		delGoods(index) {
			this.goodsInfo = 2;
			this.goodsIndex = index;
			this.subSelect();
			this.updatePrice();
		},
		updatePrice() {
			let price = 0;
			this.goodsList.forEach(item => {
				price = price + item.totalPrice * 100;
			});
			this.price = price;
		},
		closeSelect() {
			if (this.goodsIndex === 0) {
				this.selectForm.amount = this.goodsList[0].other_fee;
				this.selectForm.quantity = this.goodsList[0].other_fee_quantity;
				this.selectForm.remark = this.goodsList[0].other_fee_remark;
			} else if (this.goodsIndex != "") {
				this.selectForm = this.goodsList[this.goodsIndex];
			}
			this.picker.select = false;
		},
		onloadClient(search) {
			// 防止重复请求
			if (this.clientList.loading) {
				return;
			}
			// 设置加载状态
			this.clientList.loading = true;
			if (search != undefined) {
				this.clientList.page = 1;
				this.clientList.client_name = search;
			} else {
				this.clientList.client_name = "";
			}
			post({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search,
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		checkClient(value) {
			this.picker.client = false;
			this.client_id_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		confirmCalendar(value) {
			this.form.deliver_date = getNowFormatDate(value);
			this.picker.calendar = false;
		},
		confirmCalendarBack(value) {
			this.form.back_date = getNowFormatDate(value);
			this.picker.calendarBack = false;
		},
		getBeneficiaryList() {
			post({
				requestType: "receiving_account_list"
			})
				.then(res => {
					this.beneficiaryList.list = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		confirmBeneficiary(value) {
			this.form.beneficiary_id = value.beneficiary_id;
			this.beneficiary_id_text = value.receiving_account;
			this.picker.beneficiary = false;
		},
		updateInput(index) {
			let num = this.payment[index].number;
			let total = this.price / 100;
			if (num > total) {
				return Toast.fail("请输入小于总数的价格");
			}
			this.payment[index].percentage =
				total <= 0
					? "0%"
					: Math.round(((num / total) * 10000) / 100.0) + "%";
		},
		calendarReturn(value) {
			this.form.return_date = getNowFormatDate(value);
			this.picker.calendarReturn = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.container {
	padding-bottom: 60px;
}
.demo-panel .van-panel__footer {
	text-align: right;
}

.goods-panel {
	margin-top: 15px;
}

[class*="van-hairline"] {
	border: none;
	& + [class*="van-hairline"]:after {
		border: 0 solid #ebedf0;
	}
}

.input-right {
	display: flex;
	align-content: space-between;
	justify-items: center;
	.input-tag {
		display: flex;
		align-content: space-between;
		justify-items: center;
	}
}
</style>
